<template>
    <div
        class="filter__col app-tippy-hide-border-one-side dashboard-range-slider"
        :draggable="!isOpen"
        v-click-outside="() => (isOpen = false)"
        :class="{
            'select-mode': selectMode,
            'select-mode-1': selectModeForMainFilter === 1,
            'select-mode-2': selectModeForMainFilter === 2,
            'select-mode-3': selectModeForMainFilter === 3,
            'select-mode-4': selectModeForMainFilter === 4,
        }"
    >
        <vue-tippy
            interactive
            placement="bottom"
            animation="shift-away"
            trigger="manual"
            max-width="none"
            :hide-on-click="false"
            tag="div"
            :arrow="false"
            theme="light"
            :offset="[0, 0]"
            v-app-tippy-visible="isOpen"
            @click="buttonClick"
        >
            <div class="filter-btn no-fill" :class="filterClasses">
                <div class="filter-btn__content">
                    <svg class="sprite-icon icon filter-btn__icon" width="20" height="20">
                        <use :xlink:href="`/img/sprite.svg#filter-${iconName}`"></use>
                    </svg>
                    <span class="filter-btn__title">
                        <i18n-t :keypath="'dashboard.settings.filters.' + type" />
                    </span>
                </div>
                <div class="filter-btn__block" @click="innerButtonClick">
                    <svg
                        class="sprite-icon icon filter-btn__settings"
                        width="16"
                        height="16"
                    >
                        <use xlink:href="/img/sprite.svg#settings"></use>
                    </svg>
                </div>
            </div>

            <template #content>
                <app-range-slider
                    v-model="model"
                    :options="options"
                    :unit="rangeUnit"
                ></app-range-slider>
            </template>
        </vue-tippy>
    </div>
</template>

<script lang="ts">
import { RangeSlider } from "@/dashboard/range-slider/range-slider.ts";
export default RangeSlider;
</script>

<style scoped>
.select-mode .filter-btn.selected {
    border-color: var(--color-primary);
}

.select-mode::before {
    position: absolute;
    top: calc(50% - 11px);
    left: -10px;
    z-index: 1;
    width: 22px;
    height: 22px;
    color: white;
    background: #1aa0e1;
    border-radius: 50%;
    border: 2px solid white;
    font-family: var(--font-family);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: center;
}

.select-mode-1::before {
    content: "1";
}

.select-mode-2::before {
    content: "2";
}

.select-mode-3::before {
    content: "3";
}

.select-mode-4::before {
    content: "4";
}
</style>
